import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExternalLinkComponent } from './external-link.component';
import { ButtonModule as MatButtonModule } from '@shared/material/button';
import { DirectivesModule } from '@shared/directives';

@NgModule({
  imports: [CommonModule, MatButtonModule, DirectivesModule],
  declarations: [ExternalLinkComponent],
  exports: [ExternalLinkComponent],
})
export class ExternalLinkModule {}
